<template>
  <div class="coupon_page">
    <title-bar-back :title="'优惠券'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>

    <!-- Tab 切换 Bar -->
    <div class="switch_bar">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="switch_item"
        @click="clickBar(index)"
      >
        <span :class="{ bar_color: activeIndex === index }">{{
          item.title
        }}</span>
        <p v-if="activeIndex === index" class="bar_line" />
      </div>
    </div>

    <!-- 优惠券列表 -->
    <div class="coupon_list_container">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div v-if="list && list.length > 0" class="list_wrapper">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="coupon_cell"
            :class="
              activeIndex === 0 ? 'coupon_cell_normal' : 'coupon_cell_unable'
            "
          >
            <!-- 左侧内容区 -->
            <div class="coupon_info">
              <div class="coupon_type font14 font_weight500">
                {{ item.couponTypeStr }}券
              </div>
              <div class="coupon_message font12 font_weight500">
                {{ item.couponMessageStr }}
              </div>
              <div class="coupon_desc font10">
                {{ item.couponSpecifyMessage }};
                <br />
                有效期至{{ formatTime(item.endDate) }}
              </div>
            </div>

            <!-- 右侧操作/印章区 -->
            <div class="coupon_action">
              <div
                v-if="activeIndex === 0"
                class="use_btn"
                @click.stop="goUse(item)"
              >
                去使用
              </div>
              <img
                v-else-if="activeIndex === 1"
                src="@/assets/mine/used@2x.png"
                alt="已使用"
                class="stamp_img"
              />
              <img
                v-else-if="activeIndex === 2"
                src="@/assets/mine/un_used@2x.png"
                alt="已过期"
                class="stamp_img"
              />
            </div>
          </div>
        </div>

        <!-- 暂无优惠券 -->
        <div v-else class="none_list">
          <img src="@/assets/order/search_none_product@2x.png" alt="" />
          <div class="font14 font_weight400 colo038 line_height_20">
            暂无优惠券
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);

export default {
  name: "Coupon",
  components: {
    TitleBarBack
  },
  data() {
    return {
      tabList: [
        { title: "未使用", status: 0 },
        { title: "已使用", status: 1 },
        { title: "已过期", status: 2 }
      ],
      activeIndex: 0,
      refreshing: false
    };
  },
  computed: {
    list() {
      return this.$store.getters.couponList || [];
    }
  },
  created() {
    this.getData();
  },
  methods: {
    clickBar(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;
      this.getData();
    },
    async getData() {
      this.refreshing = true;
      const params = {
        type: this.activeIndex
      };
      try {
        await this.$store.dispatch("mine/getCouponListByUser", { params });
      } catch (err) {
        this.$toast(err?.msg || "获取优惠券列表失败");
      } finally {
        this.refreshing = false;
      }
    },
    onRefresh() {
      this.getData();
    },
    back() {
      this.$router.back();
    },
    goUse() {
      this.$router.push("/");
    },
    formatTime(timeStr) {
      if (!timeStr) return "";
      if (timeStr.length >= 10) {
        return timeStr.substring(0, 10);
      }
      return timeStr;
    }
  }
};
</script>

<style scoped>
.coupon_page {
  min-height: 100vh;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
}
.title_right {
  width: 36px;
}
.switch_bar {
  padding: 15px 0 0;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  text-align: center;
  display: flex;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.bar_color {
  color: #bf9264;
  font-weight: 500;
}
.switch_item {
  flex: 1;
  position: relative;
  padding-bottom: 10px;
  cursor: pointer;
}
.bar_line {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 3px;
  background: #bf9264;
  border-radius: 2px;
  margin: 0;
}
.coupon_list_container {
  flex: 1;
  padding: 12px;
  box-sizing: border-box;
}
.list_wrapper {
  display: flex;
  flex-direction: column;
}
.coupon_cell {
  position: relative;
  width: 100%;
  height: 98px;
  margin-bottom: 12px;
  box-sizing: border-box;
  padding: 12px 16px 12px 24px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.coupon_cell_normal {
  background-image: url("~@/assets/mine/coupon_bg_normal.png");
}
.coupon_cell_normal .coupon_type,
.coupon_cell_normal .coupon_message,
.coupon_cell_normal .coupon_desc {
  color: #fd2f60;
}
.coupon_cell_unable {
  background-image: url("~@/assets/mine/coupon_bg_unable.png");
}
.coupon_cell_unable .coupon_type,
.coupon_cell_unable .coupon_message,
.coupon_cell_unable .coupon_desc {
  color: rgba(0, 0, 0, 0.25);
}
.coupon_info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  flex: 1;
  padding-right: 8px;
}
.coupon_type {
  font-size: 14px;
  font-weight: bold;
}
.coupon_message {
  font-size: 12px;
  font-weight: 500;
  margin-top: 4px;
}
.coupon_desc {
  font-size: 10px;
  margin-top: 4px;
  line-height: 1.3;
}
.coupon_action {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
}
.use_btn {
  border: 1px solid rgba(254, 50, 100, 0.25);
  border-radius: 12px;
  color: #fd2f60;
  font-size: 14px;
  padding: 4px 12px;
  text-align: center;
  background: transparent;
  white-space: nowrap;
  cursor: pointer;
}
.stamp_img {
  width: 58px;
  height: 53px;
}
.none_list {
  margin-top: 100px;
  text-align: center;
}
.none_list img {
  width: 60px;
  margin-bottom: 8px;
}
</style>
